import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

const ROLE_ORDER = { admin: 0, dispatcher: 1, driver: 2 };

// Alle medlemmer i org-en (aktive og ventende). Bare admin og dispatcher har lesetilgang.
export function useCarrierMembers(orgId) {
  const [state, setState] = useState({ members: [], loading: Boolean(orgId) });

  useEffect(() => {
    if (!orgId) {
      setState({ members: [], loading: false });
      return undefined;
    }
    return onSnapshot(
      collection(db, 'organizations', orgId, 'members'),
      snap => setState({
        members: snap.docs
          .map(d => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (ROLE_ORDER[a.role] ?? 9) - (ROLE_ORDER[b.role] ?? 9) || String(a.name ?? '').localeCompare(String(b.name ?? ''))),
        loading: false,
      }),
      () => setState({ members: [], loading: false }),
    );
  }, [orgId]);

  return state;
}
